/** @jsx jsx */
import { jsx } from '@emotion/react';

import { Grid } from '@coursera/cds-core';

import ContentBlock from 'bundles/seo-entity-page/components/ContentBlock';
import { useSeoPageData } from 'bundles/seo/contexts/SeoPageDataContext';

const SEOConfigurationBottomContent = () => {
  const { eqpData } = useSeoPageData();
  const bottomContentBlock = eqpData?.bottomContentBlock !== null ? eqpData?.bottomContentBlock : undefined;
  if (!bottomContentBlock) return null;

  return (
    <Grid item xs={12}>
      <ContentBlock
        label={bottomContentBlock.label}
        content={bottomContentBlock.content}
        data-testid="bottom-content-block"
      />
    </Grid>
  );
};

export default SEOConfigurationBottomContent;
